export const setPostComponentData = (postComponentsJson) => ({
  id: postComponentsJson.id,
  componentId: postComponentsJson.component_id,
  position: postComponentsJson.position,
  guid: postComponentsJson.post_component_guid,
  componentName: postComponentsJson.component_name,
})
